import React from 'react';
import { extractCompanySuffix } from '../utils/company/company-name';
import { fixMojibake } from '../utils/text/fix-mojibake';

interface CompanyNameProps {
  /** The full company name including suffix */
  name: string;
  /** Optional className for the container */
  className?: string;
  /** Optional className for the main name part */
  mainNameClassName?: string;
  /** Optional className for the suffix part */
  suffixClassName?: string;
  /** Whether to apply mojibake fixing */
  fixMojibake?: boolean;
}

/**
 * Component to display a company name with the suffix shown in smaller, lightly highlighted text
 */
export function CompanyName({
  name,
  className = '',
  mainNameClassName = '',
  suffixClassName = '',
  fixMojibake: shouldFixMojibake = true,
}: CompanyNameProps) {
  if (!name) return null;

  const processedName = shouldFixMojibake ? fixMojibake(name) : name;
  const { mainName, suffix } = extractCompanySuffix(processedName);

  if (!suffix) {
    return <span className={className}>{mainName}</span>;
  }

  return (
    <span className={className}>
      <span className={mainNameClassName}>{mainName}</span>
      <span
        className={`text-[0.7em] leading-none text-gray-500 dark:text-gray-400 bg-gray-100/60 dark:bg-gray-800/60 px-1 py-0.5 rounded-sm ml-0.5 ${suffixClassName}`}
      >
        {suffix}
      </span>
    </span>
  );
}
